import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IFillSiteViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { StoreFillSitesService } from '@services/cleanfill-core/store-fill-sites/store-fill-sites.service';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class FillSiteResolver {
  constructor(private fillSiteStore: StoreFillSitesService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IFillSiteViewModel> {
    const fillSiteUniqueId = route.params.fillSiteUniqueId;

    const fillSite$ = this.fillSiteStore.getFillSite(fillSiteUniqueId).pipe(filter(Boolean), take(1));
    return fillSite$;
  }
}
